import { useCallback } from 'react';
import { AddStandardItemModal } from '@/components/modals/AddStandardItemModal';

export interface NocOption {
  code: number;
  value: string;
}

export interface AddStandardNocModalProps {
  open: boolean;
  availableNocs: NocOption[];
  loading?: boolean;
  theme?: string;
  onSave: (data: { nocCodes: number[] }) => void;
  onCancel: () => void;
}

export function AddStandardNocModal({
  open,
  availableNocs = [],
  loading,
  theme,
  onSave,
  onCancel,
}: AddStandardNocModalProps) {
  const handleSave = useCallback((selectedCodes: number[]) => {
    onSave({ nocCodes: selectedCodes });
  }, [onSave]);

  return (
    <AddStandardItemModal
      open={open}
      availableItems={availableNocs}
      loading={loading}
      itemLabelKey="value"
      itemValueKey="code"
      title="Add Standard Nature of Call"
      fieldLabel="Nature of Calls to add"
      placeholder="Select Nature of Calls..."
      requiredMessage="Nature of call(s) required."
      theme={theme}
      onSave={handleSave}
      onCancel={onCancel}
    />
  );
}

(window as any).AddStandardNocModalReact = AddStandardNocModal;
